module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hero is-bold app-navbar animated"
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('div', {
    class: {
      'navbar-burger': true, 'burger': true, 'is-active': !_vm.showBurger
    },
    on: {
      "click": function($event) {
        _vm.$emit('toggleSidebar')
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])]), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu"
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('span', {
    staticClass: "navbar-item"
  }, [_c('button', {
    staticClass: "button",
    on: {
      "click": _vm.logout
    }
  }, [_vm._m(0), _vm._v(" "), _c('span', [_vm._v("Log out")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-lg fa-sign-out"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6483b1c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Navbar.vue
// module id = 347
// module chunks = 1